import { createContext } from "react";

const ClientsContext = createContext();

export default ClientsContext;
